module.exports = __webpack_public_path__ + "static/media/fbLogo.6163476d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fbLogo.png
// module id = 683
// module chunks = 11